import React, { PureComponent } from 'react';
import { UserServiceClient } from 'fitbeat.api-clients';
import { UserProfile } from 'fitbeat.gym-core';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { AuthTokenBuilder } from '../../utils/authTokenBuilder';
import { getApiConfig } from '../../config';
import { InvitePlatformStrip } from './InvitePlatformStrip';

interface IProps {
  userProfile: UserProfile,
  t(key: string, options?: any): string;
}
interface IState {
  link: string | null;
  error: string | null;
  isLoading: boolean;
  isExpanded: boolean,
  creditDescription: string | null;
}

export class InvitePlatformCard extends PureComponent<IProps, IState> {
  private userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder());
  state = {
    link: null,
    error: null,
    creditDescription: null,
    isLoading: true,
    isExpanded: true,
  }

  public componentDidMount = async () => {
    try {
      await this.setState({ isLoading: true });
      const { link, creditDescription } = await this.userServiceClient.getOpenInviteLink();
      await this.setState({ link, creditDescription });
    } catch (error) {
      await this.setState({ error: error.message });
    } finally {
      await this.setState({ isLoading: false });
    }
  }

  public toggleBody = async () => {
    await this.setState({ isExpanded: !this.state.isExpanded });
  }

  public renderBody = () => {
    const { t, userProfile } = this.props;
    const { isLoading, link, error, creditDescription } = this.state;

    if (!isLoading && (!link || error)) {
      return (
        <View style={styles.bodyContainer}>
          <Text style={styles.error}>Oops something went wrong</Text>
        </View>
      )
    }

    return (
      <View style={styles.bodyContainer}>
        {isLoading ?
          <ActivityIndicator color={Theme.PRIMARY} />
          :
          <>
            <InvitePlatformStrip
              t={t}
              link={link}
              userProfile={userProfile}
            />
            <Text style={styles.credit}>{creditDescription}</Text>
          </>
        }
      </View>
    )
  }

  render() {
    const { t } = this.props;
    const { isExpanded } = this.state;
    return (
      <View style={styles.container}>
        <TouchableOpacity style={styles.headerContainer}
          onPress={this.toggleBody}>
          <Text style={styles.header}>{t('home:inviteFriendsToJoinPlan')}</Text>
          <Icon
            style={styles.icon}
            size={25}
            name={isExpanded ? 'ios-arrow-up-outline' : 'ios-arrow-down-outline'}
          />
        </TouchableOpacity>
        {isExpanded && this.renderBody()}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
    borderWidth: 1,
    borderRadius: 3,
    alignContent: 'center',
    justifyContent: 'center',
    borderColor: Theme.GREY_DARK_MEDIUM,
  },
  headerContainer: {
    flexDirection: 'row',
  },
  header: {
    flex: 1,
    fontSize: 16,
    alignSelf: 'center',
    textAlign: 'center',
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom700,
  },
  icon: {
    color: Theme.GREY,
    alignSelf: 'center',
  },
  bodyContainer: {
    paddingTop: 10,
  },
  error: {
    fontSize: 16,
    textAlign: 'center',
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom500,
  },
  credit: {
    paddingTop: 10,
    fontSize: 16,
    color: Theme.CHARCOAL,
    textAlign: 'center',
  },
});
